// Prevent duplicate function declaration
if (typeof window.addSorting === 'undefined') {
  window.addSorting = function(filter) {
    let newSort = [];
    newSort.push(
      {
        field: "relevance",
        order: "asc",
      },
      {
        field: "sellingPrice",
        order: "asc",
      }
    );
    filter.sort = newSort;
    // console.log("WIZ ADDING NEW SORT", filter.sort);
  };
}


function changeTemplate(div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;

  oldDiv.text = newDiv;
}

function changeTemplateMobile(div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new-mobile").text;

  oldDiv.text = newDiv;
}

document.addEventListener('DOMContentLoaded', function() {
    var elements = document.querySelectorAll('input.snize-input-style');
  setTimeout(()=>{
    elements.forEach(function(element) {
        element.style.pointerEvents = 'all';
    });  
  },10)
});

window.onWizzyScriptLoaded = function() {

function blogPostLoad(q) {
    return $.ajax({
      type: "GET",
      url: `https://countrylifefoods.com/search?q=${q}&type=article`,
      data: {
        q,
        type: "article"
      },
      success: function (response) {
        const tempDiv = document.createElement('div');

        tempDiv.innerHTML = response;

          let collectionProductGrid=null;
         collectionProductGrid = $(tempDiv).find('#CollectionProductGrid').html();
        localStorage.setItem(q, collectionProductGrid);

      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(xhr.status);
        alert(thrownError);
      }
    });
  }

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
    blogPostLoad(data.q);
    
    // Track search event
    if (window.trackSearch) {
        window.trackSearch(data.q, 0, 'wizzy_search');
    }
    
    var searchBar = document.querySelector("form#search_mini_form");

    if (searchBar) {
      searchBar.style.display = "none";
    }
    
    return data;
  });

  // Event listener for the button click
  $('body').on('click', '.wizzy-custom-button.blog', () => {
    $('#wizzy-blog-result').css('display', 'block');
    $('.wizzy-search-wrapper').css('display', 'none');
    $('.wizzy-custom-button.blog').css({'border': '2px solid black'});
    $('.wizzy-custom-button.search').css({'border': '0px solid black'});



    let res = localStorage.getItem(window.wizzyConfig.pageStore.searchInputValue);
    // console.log(res,'=>>>>>>>>>>>>res',res.length)
    if (res.length>100) {
      $('#wizzy-blog-result').html(res);

    }
    else {
      $('#wizzy-blog-result').html('<div class="wizzy-no-blogs">No Blogs Found!!!</div>');
    }

  });

  $('body').on('click', '.wizzy-custom-button.search', () => {
    $('#wizzy-blog-result').css('display', 'none');
    $('.wizzy-search-wrapper').css('display', 'block');
    $('.wizzy-custom-button.blog').css({'border': '0px solid black'});
    $('.wizzy-custom-button.search').css({'border': '2px solid black'});
  });
  // if (document.documentElement.clientWidth > 768) {
  //   let isAutocompleteMutationConfigured = false;

  //   const setMutationToAutocomplete = (id, options = {}) => {
  //     if (isAutocompleteMutationConfigured) return;

  //     let mutationHandler = (target) => {
  //       console.log(target);
  //       let targetEle = target;
  //       let isVisible;

  //       if (targetEle.hasChildNodes()) {
  //         var x = targetEle.querySelector(".wizzy-autocomplete-wrapper");
  //         if (x != null) {
  //           isVisible =
  //             window.getComputedStyle(
  //               targetEle.querySelector(".wizzy-autocomplete-wrapper")
  //             ).display === "flex";
  //         } else {
  //           return;
  //         }
  //       } else {
  //         if (targetEle.classList.contains("wizzy-autocomplete-wrapper")) {
  //           isVisible = window.getComputedStyle(targetEle).display === "flex";
  //           console.log("Came till here");
  //         } else {
  //           return;
  //         }
  //       }

  //       if (isVisible) {
  //         var x = document.querySelector(".wizzy-autocomplete-wrapper");
  //         if (getComputedStyle(x).display === "none") {
  //           document.body.classList.remove("wizzy-autocomplete-is-visible");
  //           document.body.classList.add("wizzy-autocomplete-is-not-visible");
  //         }
  //         var currentTop = parseInt(x.style.top) || 0;
  //         var newTop = currentTop + 10;
  //         x.style.top = newTop + "px";
  //         document.body.classList.add("wizzy-autocomplete-is-visible");
  //         document.body.classList.remove("wizzy-autocomplete-is-not-visible");
  //       } else {
  //         document.body.classList.remove("wizzy-autocomplete-is-visible");
  //         document.body.classList.add("wizzy-autocomplete-is-not-visible");
  //       }
  //     };

  //     let mutationStaticObserver = new MutationObserver(function (mutations) {
  //       mutations.forEach(function (mutationRecord) {
  //         switch (mutationRecord.type) {
  //           case "childList":
  //             setTimeout(function () {
  //               mutationHandler(mutationRecord.target);
  //             }, 200);
  //             break;
  //           case "subtree":
  //             break;
  //           default:
  //           // mutationHandler(mutationRecord.target);
  //         }
  //       });
  //     });

  //     mutationStaticObserver.observe(document.getElementById(id), options);
  //     isAutocompleteMutationConfigured = true;
  //   };

  //   let autocompleteId = ".wizzy-body-end-wrapper";
  //   document
  //     .querySelector(autocompleteId)
  //     .setAttribute("id", "wizzy-body-end-wrapper");
  //   setMutationToAutocomplete("wizzy-body-end-wrapper", {
  //     subtree: true,
  //     childList: true,
  //     attributes: true,
  //   });
  // }

  
  
  

  // Optimized scroll handling for desktop only - with passive listeners
  if(document.documentElement.clientWidth > 768) {
    let ticking = false;
    
    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          let searchInput = document.querySelector("header input[name='q']");
          if(searchInput) {
            if(searchInput.getBoundingClientRect().top <= 0) {
              searchInput.blur();
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Use passive listener to prevent scroll blocking
    document.addEventListener("scroll", handleScroll, { passive: true });
  }

  // Autocomplete positioning - anchors below search bar when visible
  if(document.documentElement.clientWidth > 768) {
    function positionAutocompleteWrapper() {
      const searchInput = document.querySelector("header input[name='q']");
      const autocompleteWrapper = document.querySelector(".wizzy-autocomplete-wrapper");
      
      if(!searchInput || !autocompleteWrapper) return;
      
      // Only position if autocomplete is actually visible
      const display = window.getComputedStyle(autocompleteWrapper).display;
      if(display === 'none') return;
      
      const inputRect = searchInput.getBoundingClientRect();
      // For position: fixed, top is relative to viewport
      if(inputRect.bottom > 0) {
        autocompleteWrapper.style.setProperty('top', (inputRect.bottom + 10) + 'px', 'important');
      }
    }

    // Watch for autocomplete being shown and position it
    let observerInitialized = false;
    const initObserver = function() {
      if(observerInitialized) return;
      observerInitialized = true;
      
      const observer = new MutationObserver(function(mutations) {
        for(let mutation of mutations) {
          // Check if autocomplete was added
          if(mutation.addedNodes.length) {
            for(let node of mutation.addedNodes) {
              if(node.nodeType === 1 && node.classList?.contains('wizzy-autocomplete-wrapper')) {
                setTimeout(() => positionAutocompleteWrapper(), 50);
                return;
              }
            }
          }
          // Check if display changed to visible
          if(mutation.type === 'attributes' && mutation.target.classList?.contains('wizzy-autocomplete-wrapper')) {
            const display = window.getComputedStyle(mutation.target).display;
            if(display !== 'none') {
              setTimeout(() => positionAutocompleteWrapper(), 50);
            }
          }
        }
      });
      
      observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    };
    
    // Initialize observer
    if(document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObserver);
    } else {
      setTimeout(initObserver, 100);
    }
  }

  let inputS = document.querySelector('nav input[name="q"]');

  if(inputS) {
      inputS.focus();
    inputS.onclick = function(event) {
      // console.log("working===================>")
      var searchPage = document.getElementById("search_mini_form");
      if (searchPage) {
        searchPage.style.display = "block";
      }
      let wizzyInput = document.querySelector(".wizzy-search-mobile-custom");
      if(wizzyInput) {
        wizzyInput.click();
      }
    }
  }

  var backIcon = document.querySelector(".wizzy-search-back");

  if (backIcon) {
    backIcon.addEventListener("click", function (event) {
      var wizzySearchBar = document.querySelector("form#search_mini_form");
      if (wizzySearchBar) {
        wizzySearchBar.style.display = "none";
      }
      document.body.classList.remove("scroll-lock");
      // Mobile scroll optimizer integration
      if (window.mobileScrollOptimizer) {
        document.documentElement.classList.remove('scroll-lock');
      }
    });
  }
  

  function attachQuickViewListeners() {
    let quickViewButtons = document.querySelectorAll(".quick-add-button-variants");
    quickViewButtons.forEach(function(item) {
      let hasClickLisetner = item.onclick == null ? false : true;
      if(!hasClickLisetner) {
        item.onclick = function(event) {
          event.preventDefault();
          let url = event.target.getAttribute("href");
          if(typeof wetheme !== 'undefined') {
            wetheme.toggleRightDrawer("shop-now", !0, {url: url})
          }
        }
      }
    });
  }

  // function attachAddToCartListener() {
  //   let addToCartButton = document.querySelectorAll(".wizzy-autocomplete-topproducts-addToCart-button");
  //   addToCartButton.forEarch(function(item) {
  //     item.onclick && item.onclick = function(event) {
        
  //     };
  //   });
  // }

  function attachListViewChangeListener() {
      let listViewElements = document.querySelectorAll(".wizzy-custom-list-change-one, .wizzy-custom-list-change-two, .wizzy-custom-list-change-three, .wizzy-custom-list-change-four")
        , len = listViewElements.length;
      for (let i = 0; i < len; i++)
        listViewElements[i].onclick || (listViewElements[i].onclick = function(event) {
            if (event.preventDefault(),
            this.classList.contains("active"))
                return;
            let itemsCount = this.getAttribute("data-items")
              , oneItemsEle = document.querySelector(".wizzy-custom-list-change-one")
              , twoItemsEle = document.querySelector(".wizzy-custom-list-change-two")
              , threeItemsEle = document.querySelector(".wizzy-custom-list-change-three")
              , fourItemsEle = document.querySelector(".wizzy-custom-list-change-four");
            oneItemsEle && oneItemsEle.classList.remove("active"),
            twoItemsEle && twoItemsEle.classList.remove("active"),
            threeItemsEle && threeItemsEle.classList.remove("active"),
            fourItemsEle && fourItemsEle.classList.remove("active"),
            this.classList.add("active");
            let productsPerRow = this.getAttribute("data-items")
              , parentWrapper = document.querySelector(".wizzy-search-wrapper");
            parentWrapper && parentWrapper.setAttribute("data-wizzy-products-per-row", productsPerRow)
        }
        )
  }
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {

    data.autocomplete.searchBar.animatedPlaceholderEraseTimeout = 2000;

    data.search.configs.facets.leftFacets.defaultCollapsed = !0;
    data.search.configs.facets.leftFacets.firstLeftDefaultOpened = !1;
    data.search.configs.facets.leftFacets.mobileCollapsible = !0;
    
    if(document.documentElement.clientWidth < 768) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
            "dom": '.wizzy-search-mobile-custom',
            "type": "text"
        },
        {
          'dom': 'nav input[name="q"]',
          'type': 'text'
        }
      ];  
    }else {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
            "dom": 'header input[name="q"]',
            "type": "text"
        }
      ]; 
    }
   
    
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(payload) {
     payload.endpoints.common="https://uranus-api.wizsearch.in";
     return payload;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
    if(document.documentElement.clientWidth < 768) {
      let searchBack = document.querySelector('.wizzy-search-back');
      if(searchBack) {
        searchBack.click();
      }
    }
    
    if(data.sort&&data.sort.length&&data.sort[0].field=='relevance'){
      window.addSorting(data);
    }
    
    return data;
  });
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {
    attachQuickViewListeners();
    attachListViewChangeListener();
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER, function(data) {
    
    const wizzyStore = JSON.parse(localStorage.getItem("wizzy_store"));
    if(typeof wizzyStore["SEARCHED_KEYWORDS"] !== 'undefined') {
      let searchedKeywords = wizzyStore["SEARCHED_KEYWORDS"].slice(0, 6);
      // searchedKeywords = searchedKeywords.reverse();
      
      if(typeof searchedKeywords !== 'undefined' && searchedKeywords.length > 0 && typeof data.isForDefault !== 'undefined' && data.isForDefault) {
        
  
        // searchedKeywords.forEach(function(item) {
        //   data.suggestions.unshift({
        //     "label": item,
        //     "labelPath": [],
        //     "hasLabelPath": false,
        //     "group": "recentSearches",
        //     "isHead": false,
        //     "index": 0,
        //     "searchTerm": item,
        //     "isRecentSearch": true,
        //     "isTrendingSearch": false
        //   });
        // });
  
        // data.suggestions.unshift({
        //   "label": "Recent Searches",
        //   "group": "recentSearches",
        //   "isHead": true,
        //   "hasLabelPath": false,
        //   "searchTerm": "",
        //   "index": 0,
        //   "isRecentSearch": false,
        //   "isRecentSearchHead": true
        // });
        
      }  
    }

    let suggestionsLen = data.suggestions.length;
    if(suggestionsLen > 0) {
      data.suggestions[0].index = 0;
      let index = 0;
      for(let i = 1; i < suggestionsLen; i++) {
        if(data.suggestions[i].isHead) {
          data.suggestions[i].index = index;
        }else if(data.suggestions[i - 1].isHead) {
          data.suggestions[i].index = index++;
        }else {
          data.suggestions[i].index = index++;
        }
      }
    }
    
    console.log(data, "<===BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER");
    
    return data;
  });  

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
    attachQuickViewListeners();
    attachListViewChangeListener();
    return data;
  });
  

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(data) {
    console.log(data, "<===BEFORE_RENDER_RESULTS");
    if(data.response.payload.facets) {
      data.response.payload.facets.forEach(function(item) {
        item.data.forEach(function(dataItem) {
          dataItem.label = dataItem.label.toLowerCase();
        });
      });
    }
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(data) {

    let n = data.length;
    for(let i = 0; i < n; i++) {
      let m = data[i].attributes.length;
      for(let j = 0; j < m; j++) {
        if(data[i].attributes[j].id == "product_handle") {
          let handle = data[i].attributes[j].values[0].value[0];
          data[i].mainProductUrl = "https://countrylifefoods.com/products/" + handle;
          data[i].productHandle = handle;
        }else if(data[i].attributes[j].id === "product_th_ratingValue_product_schema") {
          data[i].reviewsValue = parseFloat(data[i].attributes[j].values[0].value[0].slice(0, -1));
        }else if(data[i].attributes[j].id === "product_th_ratingCount_product_schema") {
          data[i].reviewsCount = data[i].attributes[j].values[0].value[0];
        }
      }
      
      if(data[i].reviewsValue) {
        data[i].reviewsPercentage =  (data[i].reviewsValue / 5 * 100);  
      }
    }
    
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function(data) {

    if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&!(data.filters.type==="AUTOCOMPLETE_DEFAULT")&&window.wizzyConfig.common.isOnCategoryPage===false)
    {
      window.addSorting(data.filters);
    } else if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&data.filters.type==="AUTOCOMPLETE_DEFAULT") {
      data.filters.sort = [{
        field: "relevance",
        order: "asc",
      },
      {
        field: "sellingPrice",
        order: "asc",
        isForParent: "false",
      }];
    }
    
    return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED, function(data) {

    window.addSorting(data);
    
    return data;
  });
  
  changeTemplate("wizzy-search-results-product");
  
  if(document.documentElement.clientWidth > 768) {
    changeTemplate("wizzy-search-wrapper");  
  }else {
    changeTemplateMobile("wizzy-search-wrapper");
  }
  
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-empty-results");
}













// async onAddToCart(e) {
//   console.log(e, "myyyyy eeee"),
//   e.preventDefault(),
//   this.addingToCart = !0,
//   this.hasErrors = "";
//   try {
//       const e = t()(this.$el.querySelector("#AddToCartForm")).serialize();
//       t()(this.$el.querySelector("#AddToCartForm"));
//       let n = "";
//       if (console.log("h1", e),
//       this.giftwrapProduct && this.giftwrapProductVariantId && (n = "&properties[" + this.theme.translations.giftwrap_label + "]=" + this.theme.translations.yes),
//       this.giftwrapProduct && this.giftwrapProductVariantId) {
//           const e = {
//               items: [{
//                   id: this.giftwrapProductVariantId,
//                   quantity: this.quantity
//               }]
//           }
//             , t = await window.fetch("/cart/add.js", {
//               method: "POST",
//               credentials: "same-origin",
//               headers: {
//                   "Content-Type": "application/json",
//                   "X-Requested-With": "XMLHttpRequest"
//               },
//               body: JSON.stringify(e)
//           })
//             , n = await t.json();
//           if (!t.ok)
//               return 422 == n.status && (this.hasErrors = n.description),
//               void (this.addingToCart = !1)
//       }
//       const r = await window.fetch("/cart/add.js", {
//           method: "POST",
//           credentials: "same-origin",
//           headers: {
//               "Content-Type": "application/x-www-form-urlencoded",
//               "X-Requested-With": "XMLHttpRequest"
//           },
//           body: e + n
//       })
//         , i = await r.json();
//       if (!r.ok)
//           return 422 == i.status && (this.hasErrors = i.description),
//           void (this.addingToCart = !1);
//       const o = this.languageUrl && "/" != this.languageUrl ? this.languageUrl : ""
//         , a = await window.fetch(`${o}/cart?view=compare`);
//       if (console.log(a),
//       !a.ok)
//           return void (this.addingToCart = !1);
//       const s = await a.json()
//         , l = this.$el.querySelector("[data-submit-type]");
//       let c = this.$el.querySelector("#AddToCartForm .after_added .js-drawer-open-right-link");
//       console.log(s),
//       this.addingToCart = !1,
//       "drawer" !== this.cartMethod || l ? "added" !== this.cartMethod || l ? ("page" === this.cartMethod || l) && (window.location.href = "/cart") : (this.afterAddToCart = !0,
//       setTimeout((()=>{
//           this.afterAddToCart = !1
//       }
//       ), 2e3),
//       this.theme.updateCartDrawer(s)) : this.theme.toggleRightDrawer("cart", !1, {
//           cart: s
//       }),
//       console.log("j3", c),
//       this.$el.querySelector("#AddToCartForm .after_added").style.display = "block",
//       setTimeout((()=>{
//           this.theme.progressbarcart(s)
//       }
//       ), 100)
//   } catch (e) {
//       console.error("Unable to add to cart: ", e)
//   }
// }


